<template>
    <v-btn
        v-if="isEditFab"
        icon
        @click="handleClick"
        :class="$attrs.class"
        :style="$attrs.style"
    >
        <v-icon class="edit-icon">mdi-pencil</v-icon>
    </v-btn>

    <v-btn
        v-else
        :color="disabled ? '#757575' : color"
        @click.stop="handleClick"
        :size="buttonSize"
        :variant="buttonVariant"
        :disabled="disabled"
        :rounded="rounded"
        :loading="loading"
        :type="type"
        :elevation="0"
        :class="[buttonClass, $attrs.class]"
        :style="$attrs.style"
    >
        <v-icon v-if="icon" class="button-icon">{{icon}}</v-icon>
        <slot></slot>
    </v-btn>
</template>

<script>
export default {
    inheritAttrs: false,
    emits: ['click'],
    props: {
        color: {
            type: String,
            default: 'primary'
        },
        small: {
            type: Boolean,
        },
        xSmall: {
            type: Boolean
        },
        outlined: {
            type: Boolean
        },
        disabled: {
            type: Boolean
        },
        fab: {
            type: Boolean
        },
        dark: {
            type: Boolean
        },
        rounded: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean
        },
        type: {
            type: String
        },
        isEditFab: {
            type: Boolean
        },
        depressed: {
            type: Boolean
        },
        icon: {
            type: String
        }
    },
    name: "AppButton",
    computed: {
        buttonSize() {
            if (this.xSmall) return 'x-small'
            if (this.small) return 'small'
            return 'default'
        },
        buttonVariant() {
            if (this.outlined) return 'outlined'
            // Use 'flat' for the depressed look (no shadow, solid background)
            return 'flat'
        },
        buttonClass() {
            return {
                'app-button': true,
                'app-button--light-text': !this.outlined && !this.disabled && this.color !== 'white',
                'app-button--dark-text': this.color === 'white'
            }
        }
    },
    methods: {
        handleClick(event) {
            this.$emit('click', event)
        }
    }
}
</script>

<style scoped>
.app-button {
    text-transform: none !important;
    font-weight: 500 !important;
    letter-spacing: -0.01em !important;
    font-family: 'Inter', sans-serif !important;
    border-radius: 8px !important;
    transition: all 0.2s ease !important;
    padding: 0 20px !important;
}

.app-button:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(51, 211, 255, 0.25);
}

.app-button--light-text {
    color: #fff !important;
}

.app-button--light-text :deep(.v-btn__content) {
    color: #fff !important;
}

.app-button--light-text :deep(.v-icon) {
    color: #fff !important;
}

.app-button--dark-text {
    color: #1F2937 !important;
}

.app-button--dark-text :deep(.v-btn__content) {
    color: #1F2937 !important;
}

.button-icon {
    font-size: 1.125rem;
    margin-right: 6px;
}

.edit-icon {
    color: #6B7280;
}

.edit-icon:hover {
    color: #33D3FF;
}
</style>
